import GSAP from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

GSAP.registerPlugin(ScrollTrigger)

export function bannerAnim() {
	const bannerSection = document.querySelector('.section--banner-animation')
	if (!bannerSection) return

	const leftCard = bannerSection.querySelector('.banner-animation__card--left')
	const rightCard = bannerSection.querySelector('.banner-animation__card--right')
	
	if (!leftCard || !rightCard) return

	if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return
	}

	if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
		return
	}

	requestAnimationFrame(() => {
		const pageRoot = document.querySelector('main') || document.querySelector('body')
		const rootPaddingTop = parseFloat(getComputedStyle(pageRoot).paddingTop) || 0

		const tl = GSAP.timeline({
			scrollTrigger: {
				trigger: bannerSection,
				pin: true,
				scrub: 0,
				start: () => bannerSection.getBoundingClientRect().top + window.scrollY - rootPaddingTop,
				end: () => "+=2000",
				pinSpacing: true,
			}
		})
		
		tl.to(leftCard, {
			scale: 3,
			x: '19vw',
			opacity: 0,
			ease: 'none',
			duration: 1,
		}, 0)

		tl.to(rightCard, {
			scale: 1,
			x: '50vw',
			opacity: 0.1,
			ease: 'none',
			duration: 0.92,
		}, 0)
	})
}
